import "@hotwired/turbo-rails"
Turbo.session.drive = !!document.querySelector('[data-drive-on]').dataset.driveOn
Turbo.StreamActions.alert = function () {
  const message = this.getAttribute('message');
  if (message) alert(message);
}

Turbo.StreamActions.addClass = function () {
  const classNames = this.getAttribute('classNames');

  this.targetElements.forEach((element) => {
    if (classNames) element.classList.add(classNames);
  });
}

Turbo.StreamActions.removeClass = function () {
  const classNames = this.getAttribute('classNames');

  this.targetElements.forEach((element) => {
    if (classNames) element.classList.remove(classNames);
  });
}

const VALID_MODAL_METHODS = Object.freeze(['show', 'hide', 'toggle']);
Turbo.StreamActions.controlModal = function() {
  if (!bootstrap?.Modal) {
    console.error('Bootstrap is not available for modal control');
    return;
  }

  const method = this.getAttribute('method');
  if (!VALID_MODAL_METHODS.includes(method)) return;

  this.targetElements.forEach((element) => {
    const bsModal = bootstrap.Modal.getOrCreateInstance(element);
    if (bsModal) {
      bsModal[method]();
    }
  });
}